import { NEXT_PUBLIC_APP_URL } from 'constants/env';

export const REFERRAL_LINK_EXPIRY_PERIOD_MS = 1000 * 60 * 60 * 24 * 7; // one week
export const REFERRAL_LINK_EXPIRY_PERIOD_MULTIPLIER = 2; // the link expires one week (the period above); other than this week, we let the user to use it 1 more week (2 in total); if someone generates a link 1h before expiry, it would be useless without this rule
export const makeReferralLink = (id: string) => `${NEXT_PUBLIC_APP_URL}/referral/${id}`;
